
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3PxNF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Onboarding", () => $a897d0c7ea71f2b3$export$70238cd3868b67c9);
$parcel$export(module.exports, "default", () => $a897d0c7ea71f2b3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $lgd3t = parcelRequire("lgd3t");

var $4QigF = parcelRequire("4QigF");

var $77Zff = parcelRequire("77Zff");
const $a897d0c7ea71f2b3$export$70238cd3868b67c9 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    if (!(0, $77Zff.shouldRouteShowQuickstartOnboarding)(route.name)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lgd3t.JswQuickStartShouldRender), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4QigF.JswOnboardingButton), null));
};
var $a897d0c7ea71f2b3$export$2e2bcd8739ae039 = $a897d0c7ea71f2b3$export$70238cd3868b67c9;

});
parcelRegister("lgd3t", function(module, exports) {

$parcel$export(module.exports, "JswQuickStartShouldRender", () => $965d07c32b6c14f6$export$66f5975ba6556512);

var $iG76j = parcelRequire("iG76j");
const $965d07c32b6c14f6$export$66f5975ba6556512 = (0, $iG76j.default);

});
parcelRegister("iG76j", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6c61bf75aaa2492$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $8GOso = parcelRequire("8GOso");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $4DPZY = parcelRequire("4DPZY");

var $dAfqg = parcelRequire("dAfqg");

var $doZTA = parcelRequire("doZTA");

var $4igab = parcelRequire("4igab");
/*
    This hook will be used in spa-app in order to set the shouldRenderComponent
    when it is loaded in side of the proper paths. Once it is unmounted it should set the component to false.
    Next-Gen:
        Board: jira/software/projects/MT1/boards/1 --> spa-app/next-gen-board
        Backlog: jira/software/projects/MT1/boards/1/backlog --> spa-app/next-gen-backlog
        Roadmap: jira/software/projects/MT1/boards/1/roadmap --> spa-app/roadmap/src/view/common/roadmap
        Project Setting (Details): /jira/software/projects/MT1/settings/details --> spa-app/project-settings/details
        Pages: projects/MT1?selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page --> spa-app/project/pages
    Classic:
        Board: secure/RapidBoard.jspa?projectKey=CK&rapidView=5 --> spa-app/rapid-board
        Backlog: secure/RapidBoard.jspa?rapidView=5&projectKey=CK&view=planning.nodetail&issueLimit=100 --> spa-app/rapid-board
    Both:
        OpsGenie: projects/CK?selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page --> spa-app/project/opsgenie-schedule

*/ const $b6c61bf75aaa2492$var$QuickstartShouldRenderWithoutPersonalisation = (props)=>{
    const [{ match: match, route: route }] = (0, $doZTA.useRouter)();
    const { projectContext: projectContext } = props;
    // Require to calculate analytics attributes in this component
    const [{ data: containerContext }] = (0, $4DPZY.useContainerContext)();
    const projectContextData = projectContext && projectContext.data;
    const { canShowExperience: canShowExperience, isEnrolledForProjectSettings: isEnrolledForProjectSettings } = (0, $4igab.useQuickstartInitialise)(projectContextData);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (canShowExperience && isEnrolledForProjectSettings) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'invitePeopleToProject shouldRender', {
                isNextGen: Boolean(projectContextData && projectContextData.simplified)
            });
        }
    }, [
        canShowExperience,
        containerContext,
        createAnalyticsEvent,
        isEnrolledForProjectSettings,
        match,
        projectContextData,
        route
    ]);
    return null;
};
const $b6c61bf75aaa2492$var$QuickstartShouldRenderWithPersonalisation = (props)=>{
    const [{ match: match, route: route }] = (0, $doZTA.useRouter)();
    const { projectContext: projectContext } = props;
    // Require to calculate analytics attributes in this component
    const [{ data: containerContext }] = (0, $4DPZY.useContainerContext)();
    const projectContextData = projectContext && projectContext.data;
    const { canShowExperience: canShowExperience, isEnrolledForProjectSettings: isEnrolledForProjectSettings } = (0, $4igab.useQuickstartInitialiseWithPersonalisation)(projectContextData);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (canShowExperience && isEnrolledForProjectSettings) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'invitePeopleToProject shouldRender', {
                isNextGen: Boolean(projectContextData && projectContextData.simplified)
            });
        }
    }, [
        canShowExperience,
        containerContext,
        createAnalyticsEvent,
        isEnrolledForProjectSettings,
        match,
        projectContextData,
        route
    ]);
    return null;
};
const $b6c61bf75aaa2492$export$15fdcfee517a071d = (0, $7XYc4.componentWithCondition)(()=>{
    const isEligibleForJtbdOnboarding = (0, $8GOso.useCommonEligibilityConditionsForJtbdOnboarding)();
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_tailored_onboarding_jtbd');
    return isEligibleForJtbdOnboarding && expConfig.get('isEnabled', false);
}, $b6c61bf75aaa2492$var$QuickstartShouldRenderWithPersonalisation, $b6c61bf75aaa2492$var$QuickstartShouldRenderWithoutPersonalisation);
const $b6c61bf75aaa2492$var$QuickstartShouldRenderWithProjectContext = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "QuickStartShouldRender",
        packageName: "jiraSoftwareOnboardingQuickstart",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jlove-makkuro",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c61bf75aaa2492$export$15fdcfee517a071d, {
            projectContext: projectContext
        })));
var $b6c61bf75aaa2492$export$2e2bcd8739ae039 = $b6c61bf75aaa2492$var$QuickstartShouldRenderWithProjectContext;

});
parcelRegister("4igab", function(module, exports) {

$parcel$export(module.exports, "useQuickstartInitialise", () => $acadf6219835098e$export$10654bdbbe3c2561);
$parcel$export(module.exports, "useQuickstartInitialiseWithPersonalisation", () => $acadf6219835098e$export$6ef8438579867e87);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $izudm = parcelRequire("izudm");

var $i6yVb = parcelRequire("i6yVb");

var $8GOso = parcelRequire("8GOso");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $byS8t = parcelRequire("byS8t");

var $h9iZl = parcelRequire("h9iZl");

var $6jY6G = parcelRequire("6jY6G");

var $bngFq = parcelRequire("bngFq");

var $gh567 = parcelRequire("gh567");


var $fZRGa = parcelRequire("fZRGa");


var $jrUuh = parcelRequire("jrUuh");

var $ldyPw = parcelRequire("ldyPw");

var $heI7y = parcelRequire("heI7y");

var $9OXo1 = parcelRequire("9OXo1");

var $doZTA = parcelRequire("doZTA");

var $4R6GH = parcelRequire("4R6GH");

var $gWE9S = parcelRequire("gWE9S");

var $6MqfV = parcelRequire("6MqfV");

var $bPD6R = parcelRequire("bPD6R");

var $2S7gn = parcelRequire("2S7gn");

var $lQB52 = parcelRequire("lQB52");
const $acadf6219835098e$export$10654bdbbe3c2561 = (projectContextData)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const isTrelloCrossflow = (0, $i6yVb.useIsTrelloCrossflowEnabled)();
    const canShowExperience = (0, $2S7gn.useQuickstart)(projectContextData);
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $6MqfV.useRefreshOnJSMProjectSwitch)(projectContextData?.projectId, projectContextData?.projectType);
    const canEditPlans = (0, $h9iZl.useNavigationEditPlansPermission)();
    const isAdvancedRoadmapsTrial = (0, $h9iZl.useIsAdvancedRoadmapsTrial)();
    const isTargetedForReverseTrials = (0, $gh567.useIsTargetedForReverseTrials)();
    const [{ isQuickstartLoaded: isQuickstartLoaded, shouldRenderComponent: shouldRenderComponent }, { refreshAppState: refreshAppState, setShouldRenderComponent: setShouldRenderComponent, forceHideNudge: forceHideNudge, setProjectState: setProjectState, syncVisibilityWithLocal: syncVisibilityWithLocal }] = (0, $cE2Qr.useJswOnboarding)();
    const [{ hasOpened: hasOpened }, { setHasOpened: setHasOpened }] = (0, $heI7y.useHasOpened)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [, { fetchProjectProperties: fetchProjectProperties }] = (0, $izudm.useProjectPropertiesService)();
    const [isSampleProject, { fetchIsSampleProject: fetchIsSampleProject }] = (0, $gWE9S.useIsSampleProjectService)();
    const canInvitePeopleToProject = (0, $lQB52.getCanInvitePeopleToProject)(projectContextData, tenantContext);
    const route = (0, $6jY6G.useCurrentRoute)();
    const isProjectSettingsPage = (0, $8Bc5A.PROJECT_SETTING_PAGES).includes(route.name);
    const isEnrolledForProjectSettings = isProjectSettingsPage && canShowExperience && canInvitePeopleToProject;
    const hasLoadedRemoteState = (0, $5uXOq.useRef)(false);
    const [{ location: location }] = (0, $doZTA.useRouter)();
    (0, $5uXOq.useEffect)(()=>{
        if (projectContextData?.projectKey && projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT)) fetchIsSampleProject(projectContextData.projectKey);
    }, [
        fetchIsSampleProject,
        projectContextData?.projectKey,
        projectContextData?.projectType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (projectContextData?.projectType !== (0, $2vSU6.SOFTWARE_PROJECT)) return;
        const projectId = projectContextData?.projectId.toString();
        if (projectId) fetchProjectProperties(projectId);
    }, [
        fetchProjectProperties,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!projectContextData) return;
        const { projectKey: projectKey, projectName: projectName, projectId: projectId, simplified: isNextGen, projectType: projectType, isProjectAdmin: isProjectAdminMaybe } = projectContextData;
        setProjectState({
            canInvitePeopleToProject: canInvitePeopleToProject,
            projectKey: projectKey,
            projectId: projectId,
            projectName: projectName,
            isNextGen: isNextGen,
            projectType: projectType,
            isProjectAdmin: Boolean(isProjectAdminMaybe),
            userRole: (0, $lQB52.getUserRole)(tenantContext.isSiteAdmin, tenantContext.isAdmin),
            edition: (0, $ldyPw.getEditionForProject)(projectType, tenantContext.appEditions),
            isSampleProject: isSampleProject[projectKey],
            isTrelloCrossflow: isTrelloCrossflow
        });
    }, [
        setProjectState,
        projectContextData,
        canInvitePeopleToProject,
        isProjectSettingsPage,
        tenantContext,
        isSampleProject,
        isTrelloCrossflow
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData
    ]);
    // When the component is re-mounted after the initial remote state load.
    (0, $5uXOq.useEffect)(()=>{
        // We can show the experience and are in the right page or experiment.
        const pathNameWithoutTrailingSlash = (0, $fZRGa.extractTrailingSlashFromPath)(location.pathname);
        const isJsmBusinessPeopleSettingsPage = projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691) && pathNameWithoutTrailingSlash.endsWith((0, $08a37b02293d63ea$export$d2fcfad22215d3a3));
        const canReallyShowExperience = canShowExperience && // TODO: move this logic inside the useQuickstart hook (canShowExperience)
        (isJsmBusinessPeopleSettingsPage || !isProjectSettingsPage || canInvitePeopleToProject);
        if (!canReallyShowExperience) return;
        const projectType = projectContextData?.projectType;
        if (!isQuickstartLoaded && !hasLoadedRemoteState.current) {
            if (quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED || quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED) {
                syncVisibilityWithLocal();
                return;
            }
            // We need to load QuickStart remote data.
            hasLoadedRemoteState.current = true;
            const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin } = tenantContext;
            refreshAppState({
                atlassianAccountId: atlassianAccountId,
                cloudId: cloudId,
                appEditions: appEditions,
                isAdmin: isAdmin,
                createAnalyticsEvent: createAnalyticsEvent,
                canEditPlans: canEditPlans,
                isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial,
                isTargetedForReverseTrials: isTargetedForReverseTrials,
                projectType: projectType
            });
            return;
        }
        if (!shouldRenderComponent && isQuickstartLoaded) // Quickstart has loaded data but currently hidden.
        setShouldRenderComponent(true);
    }, [
        refreshAppState,
        canInvitePeopleToProject,
        canShowExperience,
        isProjectSettingsPage,
        isQuickstartLoaded,
        setShouldRenderComponent,
        shouldRenderComponent,
        tenantContext,
        location.pathname,
        projectContextData,
        jsmOnboardingData,
        createAnalyticsEvent,
        canEditPlans,
        isAdvancedRoadmapsTrial,
        isTargetedForReverseTrials,
        quickstartStatus,
        syncVisibilityWithLocal
    ]);
    /**
		Note: We triggers feature exposure for our
		Invite people to project experiment,
		If user is in project settings page.
		FD Ticket: https://hello.atlassian.net/browse/FD-15096
	*/ (0, $5uXOq.useEffect)(()=>// When component unmounts we should set shouldRenderComponent to false
        ()=>{
            // NOTE: we need to make sure the nudge is not active when the component unmounts.
            // This prevents seeing the nudge flickering if a user navigates when the nudge
            // is active for example.
            forceHideNudge();
            setShouldRenderComponent(false);
        }, [
        setShouldRenderComponent,
        forceHideNudge
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isQuickstartLoaded === true && quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && hasOpened === false) setHasOpened();
    }, [
        isQuickstartLoaded,
        quickstartStatus,
        setHasOpened,
        hasOpened
    ]);
    return {
        canShowExperience: canShowExperience,
        isEnrolledForProjectSettings: isEnrolledForProjectSettings
    };
};
const $acadf6219835098e$export$6ef8438579867e87 = (projectContextData)=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const isTrelloCrossflow = (0, $i6yVb.useIsTrelloCrossflowEnabled)();
    const canShowExperience = (0, $2S7gn.useQuickstart)(projectContextData);
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $bPD6R.useRefreshQuickstartOnProjectSwitch)(projectContextData);
    const convertToRootTaskList = (0, $byS8t.useConvertToRootTaskList)();
    const canEditPlans = (0, $h9iZl.useNavigationEditPlansPermission)();
    const isAdvancedRoadmapsTrial = (0, $h9iZl.useIsAdvancedRoadmapsTrial)();
    const isTargetedForReverseTrials = (0, $gh567.useIsTargetedForReverseTrials)();
    const [{ isQuickstartLoaded: isQuickstartLoaded, shouldRenderComponent: shouldRenderComponent }, { refreshAppState: refreshAppState, refreshAppStateUiStatusOnly: refreshAppStateUiStatusOnly, setShouldRenderComponent: setShouldRenderComponent, forceHideNudge: forceHideNudge, setProjectState: setProjectState }] = (0, $cE2Qr.useJswOnboarding)();
    const isEligibleForJtbdOnboarding = (0, $8GOso.useCommonEligibilityConditionsForJtbdOnboarding)();
    // TODO: Can share this variable with rest of file
    const projectTypeForTO = (0, $4R6GH.fg)('tailored_onboarding_m3_gate') ? projectContextData?.projectType : (0, $2vSU6.CORE_PROJECT);
    const { isReady: personalisationDataIsReady, data: personalisationData } = (0, $8GOso.useTailoredOnboardingPersonalisationM2)({
        isEligible: isEligibleForJtbdOnboarding,
        additionalParameters: {
            projectType: projectTypeForTO
        }
    });
    const [{ hasOpened: hasOpened }, { setHasOpened: setHasOpened }] = (0, $heI7y.useHasOpened)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [, { fetchProjectProperties: fetchProjectProperties }] = (0, $izudm.useProjectPropertiesService)();
    const [isSampleProject, { fetchIsSampleProject: fetchIsSampleProject }] = (0, $gWE9S.useIsSampleProjectService)();
    const canInvitePeopleToProject = (0, $lQB52.getCanInvitePeopleToProject)(projectContextData, tenantContext);
    const route = (0, $6jY6G.useCurrentRoute)();
    const isProjectSettingsPage = (0, $8Bc5A.PROJECT_SETTING_PAGES).includes(route.name);
    const isEnrolledForProjectSettings = isProjectSettingsPage && canShowExperience && canInvitePeopleToProject;
    const hasLoadedRemoteState = (0, $5uXOq.useRef)(false);
    const [{ location: location }] = (0, $doZTA.useRouter)();
    (0, $5uXOq.useEffect)(()=>{
        if (projectContextData?.projectKey && projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT)) fetchIsSampleProject(projectContextData.projectKey);
    }, [
        fetchIsSampleProject,
        projectContextData?.projectKey,
        projectContextData?.projectType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (projectContextData?.projectType !== (0, $2vSU6.SOFTWARE_PROJECT)) return;
        const projectId = projectContextData?.projectId.toString();
        if (projectId) fetchProjectProperties(projectId);
    }, [
        fetchProjectProperties,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!projectContextData) return;
        const { projectKey: projectKey, projectName: projectName, projectId: projectId, simplified: isNextGen, projectType: projectType, isProjectAdmin: isProjectAdminMaybe } = projectContextData;
        setProjectState({
            canInvitePeopleToProject: canInvitePeopleToProject,
            projectKey: projectKey,
            projectId: projectId,
            projectName: projectName,
            isNextGen: isNextGen,
            projectType: projectType,
            isProjectAdmin: Boolean(isProjectAdminMaybe),
            userRole: (0, $lQB52.getUserRole)(tenantContext.isSiteAdmin, tenantContext.isAdmin),
            edition: (0, $ldyPw.getEditionForProject)(projectType, tenantContext.appEditions),
            isSampleProject: isSampleProject[projectKey],
            isTrelloCrossflow: isTrelloCrossflow
        });
    }, [
        setProjectState,
        projectContextData,
        canInvitePeopleToProject,
        isProjectSettingsPage,
        tenantContext,
        isSampleProject,
        isTrelloCrossflow
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData
    ]);
    // When the component is re-mounted after the initial remote state load.
    (0, $5uXOq.useEffect)(()=>{
        // We can show the experience and are in the right page or experiment.
        const pathNameWithoutTrailingSlash = (0, $fZRGa.extractTrailingSlashFromPath)(location.pathname);
        const isJsmBusinessPeopleSettingsPage = projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691) && pathNameWithoutTrailingSlash.endsWith((0, $08a37b02293d63ea$export$d2fcfad22215d3a3));
        const canReallyShowExperience = canShowExperience && // TODO: move this logic inside the useQuickstart hook (canShowExperience)
        (isJsmBusinessPeopleSettingsPage || !isProjectSettingsPage || canInvitePeopleToProject);
        if (!canReallyShowExperience) return;
        const projectType = projectContextData?.projectType;
        if (personalisationDataIsReady && !isQuickstartLoaded && !hasLoadedRemoteState.current) {
            // We need to load QuickStart remote data.
            hasLoadedRemoteState.current = true;
            if (personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0 && // For Tailored onboarding M3, we have an option to stick to the FE and avoid the BE since M2 scoped the BE call to business projects
            projectType === (0, $2vSU6.CORE_PROJECT)) {
                const taskList = convertToRootTaskList(personalisationData.QUICKSTART);
                refreshAppStateUiStatusOnly({
                    taskList: taskList
                });
            } else {
                const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin } = tenantContext;
                refreshAppState({
                    atlassianAccountId: atlassianAccountId,
                    cloudId: cloudId,
                    appEditions: appEditions,
                    isAdmin: isAdmin,
                    createAnalyticsEvent: createAnalyticsEvent,
                    canEditPlans: canEditPlans,
                    isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial,
                    isTargetedForReverseTrials: isTargetedForReverseTrials,
                    projectType: projectType
                });
            }
            return;
        }
        if (!shouldRenderComponent && isQuickstartLoaded) // Quickstart has loaded data but currently hidden.
        setShouldRenderComponent(true);
    }, [
        refreshAppState,
        canInvitePeopleToProject,
        canShowExperience,
        isProjectSettingsPage,
        isQuickstartLoaded,
        refreshAppStateUiStatusOnly,
        createAnalyticsEvent,
        canEditPlans,
        isAdvancedRoadmapsTrial,
        isTargetedForReverseTrials,
        location.pathname,
        projectContextData?.projectType,
        jsmOnboardingData?.onboardingType,
        personalisationDataIsReady,
        shouldRenderComponent,
        personalisationData.QUICKSTART,
        tenantContext,
        setShouldRenderComponent,
        convertToRootTaskList
    ]);
    /**
		Note: We triggers feature exposure for our
		Invite people to project experiment,
		If user is in project settings page.
		FD Ticket: https://hello.atlassian.net/browse/FD-15096
	*/ (0, $5uXOq.useEffect)(()=>// When component unmounts we should set shouldRenderComponent to false
        ()=>{
            // NOTE: we need to make sure the nudge is not active when the component unmounts.
            // This prevents seeing the nudge flickering if a user navigates when the nudge
            // is active for example.
            forceHideNudge();
            setShouldRenderComponent(false);
        }, [
        setShouldRenderComponent,
        forceHideNudge
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isQuickstartLoaded === true && quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && hasOpened === false) setHasOpened();
    }, [
        isQuickstartLoaded,
        quickstartStatus,
        setHasOpened,
        hasOpened
    ]);
    return {
        canShowExperience: canShowExperience,
        isEnrolledForProjectSettings: isEnrolledForProjectSettings
    };
};

});
parcelRegister("izudm", function(module, exports) {

$parcel$export(module.exports, "useProjectPropertiesService", () => $c39c36d4c5856c65$export$fbbfd9681b40a5aa);
$parcel$export(module.exports, "useProjectProperties", () => $c39c36d4c5856c65$export$58be98885c2d686a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $ajzpG = parcelRequire("ajzpG");
const $c39c36d4c5856c65$export$d4c72bab9d6cc13a = {};
const $c39c36d4c5856c65$var$store = (0, $iXqE5.createStore)({
    name: 'jsw-customer-template-project-properties',
    initialState: $c39c36d4c5856c65$export$d4c72bab9d6cc13a,
    actions: $ajzpG.actions
});
const $c39c36d4c5856c65$export$fbbfd9681b40a5aa = (0, $3sQ5x.createHook)($c39c36d4c5856c65$var$store);
const $c39c36d4c5856c65$export$b03f41833a4b2b39 = (0, $3sQ5x.createHook)($c39c36d4c5856c65$var$store, {
    selector: (state, projectId)=>{
        if (!projectId || !state[projectId] || state[projectId].fetchStatus === 'fetching') return null;
        return state[projectId];
    }
});
const $c39c36d4c5856c65$export$58be98885c2d686a = (projectId)=>{
    const [lastFetchedProjectProperties] = $c39c36d4c5856c65$export$b03f41833a4b2b39(projectId);
    const defaultProjectPropertiesState = {
        isCustomerTemplateProject: false,
        templateKey: ''
    };
    const [projectProperties, setProjectProperties] = (0, $5uXOq.useState)(lastFetchedProjectProperties || defaultProjectPropertiesState);
    (0, $5uXOq.useEffect)(()=>{
        if (!lastFetchedProjectProperties || projectProperties.templateKey === lastFetchedProjectProperties.templateKey) return;
        setProjectProperties(lastFetchedProjectProperties);
    }, [
        lastFetchedProjectProperties,
        projectId,
        projectProperties.templateKey
    ]);
    return projectProperties;
};

});
parcelRegister("ajzpG", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5bb3e5348eb7cc0a$export$e324594224ef24da);

var $hxsSm = parcelRequire("hxsSm");
const $5bb3e5348eb7cc0a$export$e324594224ef24da = {
    fetchProjectProperties: $hxsSm.fetchProjectProperties
};

});
parcelRegister("hxsSm", function(module, exports) {

$parcel$export(module.exports, "fetchProjectProperties", () => $8fc53a0b2aec42fe$export$79e8674bc04f59fe);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $aMFGn = parcelRequire("aMFGn");

var $WUiK5 = parcelRequire("WUiK5");
const $8fc53a0b2aec42fe$export$79e8674bc04f59fe = (projectId)=>async ({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const currentStateForProjectId = currentState[projectId];
        if (currentStateForProjectId?.fetchStatus === 'fetched' || currentStateForProjectId?.fetchStatus === 'fetching') return;
        setState({
            [projectId]: {
                ...currentStateForProjectId,
                fetchStatus: 'fetching'
            }
        });
        const response = await (0, $WUiK5.performGetProjectPropertiesRequest)({
            projectId: projectId
        });
        if (response) {
            const templateKey = response['initial.project.template.name'];
            const isCustomerTemplateProject = typeof templateKey === 'string' && (0, $aMFGn.isCustomerTemplateKey)(templateKey);
            setState({
                [projectId]: {
                    fetchStatus: 'fetched',
                    isCustomerTemplateProject: isCustomerTemplateProject,
                    templateKey: templateKey
                }
            });
        }
    };

});
parcelRegister("aMFGn", function(module, exports) {

$parcel$export(module.exports, "isCustomerTemplateKey", () => $74a8ba700edd78f6$export$611b4f72a5e09f36);
const $74a8ba700edd78f6$export$611b4f72a5e09f36 = (key)=>key.indexOf('customer-template.') > -1;

});

parcelRegister("WUiK5", function(module, exports) {

$parcel$export(module.exports, "performGetProjectPropertiesRequest", () => $78348bb0ed8d9906$export$70811087b41197e6);

var $eusud = parcelRequire("eusud");

var $h4tc3 = parcelRequire("h4tc3");
const $78348bb0ed8d9906$export$70811087b41197e6 = async ({ projectId: projectId })=>{
    try {
        // Note: Could NOT use getUserProperties from other packages
        // because of bug where that function performs JSON.Parse on all response data, but the BE
        // data we are fetching here is not stored in a JSON format.
        const params = new URLSearchParams();
        params.append('projectId', projectId);
        params.append('project', 'initial.project.template.name');
        const { project: project } = await (0, $eusud.performGetRequest)(`/rest/internal/latest/frontendconfig/properties?${params.toString()}`);
        return project;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error?.statusCode === 404) return null;
        (0, $h4tc3.fireErrorAnalytics)({
            subject: 'getIsCustomerTemplateProject'
        }, error);
        return null;
    }
};

});
parcelRegister("h4tc3", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $5d7623d19637ceee$export$a27c21aa3ed8f0f1);

var $jcw0u = parcelRequire("jcw0u");
const $5d7623d19637ceee$export$a27c21aa3ed8f0f1 = (attributes, error)=>{
    (0, $jcw0u.default)({
        meta: {
            packageName: 'jiraSoftwareCustomerTemplates',
            teamName: 'jlove-makkuro',
            id: 'jiraSoftwareCustomerTemplates'
        },
        attributes: attributes,
        error: error
    });
};

});





parcelRegister("i6yVb", function(module, exports) {

$parcel$export(module.exports, "useIsTrelloCrossflowEnabled", () => $d8636b504a9bdfe4$export$9ab9cbe3c36cf94c);

var $5uXOq = parcelRequire("5uXOq");

var $koeKL = parcelRequire("koeKL");

var $5GDqD = parcelRequire("5GDqD");

var $k6Mdf = parcelRequire("k6Mdf");
const $d8636b504a9bdfe4$export$9ab9cbe3c36cf94c = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { fetchTraits: fetchTraits } = (0, $5GDqD.useTraitsActions)();
    (0, $5uXOq.useEffect)(()=>{
        fetchTraits([
            'SITE'
        ], {
            cloudId: cloudId
        });
    }, [
        fetchTraits,
        cloudId
    ]);
    const [isTrelloWorkspaceLinked] = (0, $k6Mdf.useLinkedTrelloWorkspaceTraitSelector)();
    return isTrelloWorkspaceLinked;
};

});
parcelRegister("5GDqD", function(module, exports) {

$parcel$export(module.exports, "useTraits", () => $5e4cf08f88a8a143$export$243330301a7ccf01);
$parcel$export(module.exports, "useTraitsActions", () => $5e4cf08f88a8a143$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $5e4cf08f88a8a143$export$fb8309e220d0dd3b);

var $eusud = parcelRequire("eusud");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $jX0pr = parcelRequire("jX0pr");

var $8ilPk = parcelRequire("8ilPk");

var $13UaH = parcelRequire("13UaH");

var $2LwjF = parcelRequire("2LwjF");
const $5e4cf08f88a8a143$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $5e4cf08f88a8a143$var$fetchTraitsOld = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $2LwjF.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $13UaH.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                const fetchedTraits = await (0, $eusud.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $5e4cf08f88a8a143$var$fetchTraitsNew = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $2LwjF.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $13UaH.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                let fetchedTraits = null;
                // TODO: in the future, we will need to also memoise site user trait and user trait here
                // Thus, we need to add FG at each conditions to fetch if we should use the memoised fetcher
                if (traitType === (0, $13UaH.SITE) && cloudId && (0, $4R6GH.fg)('site-trait-iv-llc-unnecessary-api')) fetchedTraits = {
                    attributes: await (0, $jX0pr.memoizedFetchSitePersonalization)({
                        cloudId: cloudId
                    })
                };
                else if (traitType === (0, $13UaH.SITE_USER) && cloudId && accountId && (0, $4R6GH.fg)('site-user-trait-iv-llc-unnecessary-api')) fetchedTraits = {
                    attributes: await (0, $8ilPk.memoizedFetchSiteUserPersonalization)({
                        cloudId: cloudId,
                        userId: accountId
                    })
                };
                else fetchedTraits = await (0, $eusud.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $5e4cf08f88a8a143$var$fetchTraits = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('site-trait-iv-llc-unnecessary-api') || (0, $4R6GH.fg)('site-user-trait-iv-llc-unnecessary-api'), $5e4cf08f88a8a143$var$fetchTraitsNew, $5e4cf08f88a8a143$var$fetchTraitsOld);
const $5e4cf08f88a8a143$var$actions = {
    fetchTraits: $5e4cf08f88a8a143$var$fetchTraits,
    addTrait: $5e4cf08f88a8a143$var$addTrait
};
const $5e4cf08f88a8a143$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE_USER: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG_USER: {
        attributes: null,
        loading: false,
        loaded: false
    }
};
const $5e4cf08f88a8a143$export$5b11e13f463f4eb = (0, $iXqE5.createStore)({
    initialState: $5e4cf08f88a8a143$var$initialState,
    actions: $5e4cf08f88a8a143$var$actions,
    name: 'TraitsStore'
});
const $5e4cf08f88a8a143$export$243330301a7ccf01 = (0, $3sQ5x.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$export$87f1d888def9d5a0 = (0, $3sQ5x.createActionsHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$var$defaultSelector = (traitsType, selector)=>(0, $6dDSs.createSelector)((state)=>({
            loading: !!state[traitsType]?.loading,
            loaded: state[traitsType]?.loaded || false,
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].loaded ? (0, $2LwjF.userCreatedAfter)(state, date) : false,
            userCreatedBefore: (date)=>state[traitsType].loaded ? (0, $2LwjF.userCreatedBefore)(state, date) : false,
            getTraitByName: (name)=>state[traitsType].loaded ? (0, $2LwjF.getTraitByName)(state, name) : null,
            hasTrait: (name)=>state[traitsType].loaded ? (0, $2LwjF.hasTrait)(state, name) : false,
            getTraitValue: (name)=>state[traitsType].loaded ? (0, $2LwjF.getTraitValue)(state, name) : null
        }), selector);
const $5e4cf08f88a8a143$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $3sQ5x.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb, {
        selector: $5e4cf08f88a8a143$var$defaultSelector(traitsType, selector)
    });
const $5e4cf08f88a8a143$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("13UaH", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $c8223610b88d815b$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $c8223610b88d815b$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $c8223610b88d815b$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $c8223610b88d815b$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $c8223610b88d815b$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $c8223610b88d815b$export$ff5c5bd50c21e9a4);
const $c8223610b88d815b$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $c8223610b88d815b$export$1f4740cb59ea887e = 'SITE';
const $c8223610b88d815b$export$2b629adc0b711448 = 'SITE_USER';
const $c8223610b88d815b$export$c7bc89c720838974 = 'ORG';
const $c8223610b88d815b$export$872e93425a929c06 = 'ORG_USER';
const $c8223610b88d815b$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $c8223610b88d815b$export$ab3e7784d2a104d4 = [
    $c8223610b88d815b$export$eac8289d83d13c9e,
    $c8223610b88d815b$export$1f4740cb59ea887e,
    $c8223610b88d815b$export$2b629adc0b711448,
    $c8223610b88d815b$export$c7bc89c720838974,
    $c8223610b88d815b$export$872e93425a929c06
];

});

parcelRegister("2LwjF", function(module, exports) {

$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $a4882989c0079311$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $a4882989c0079311$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "hasTrait", () => $a4882989c0079311$export$252a469687875173);
$parcel$export(module.exports, "getTraitValue", () => $a4882989c0079311$export$43a43c2e6ec7b13);
$parcel$export(module.exports, "userCreatedAfter", () => $a4882989c0079311$export$8388eb33623a9cff);
$parcel$export(module.exports, "userCreatedBefore", () => $a4882989c0079311$export$da1e8ce191f01409);

var $13UaH = parcelRequire("13UaH");
const $a4882989c0079311$export$e320a062b20fddc3 = (traitsData)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $a4882989c0079311$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $13UaH.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $13UaH.SITE:
            return `site/${cloudId}`;
        case 0, $13UaH.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $13UaH.ORG:
            return `org/${orgId}`;
        case 0, $13UaH.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName);
}
function $a4882989c0079311$export$252a469687875173(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName) !== undefined;
}
function $a4882989c0079311$export$43a43c2e6ec7b13(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName)?.value ?? null;
}
const $a4882989c0079311$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$a4882989c0079311$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $a4882989c0079311$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};
const $a4882989c0079311$export$da1e8ce191f01409 = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) < date;
};

});


parcelRegister("k6Mdf", function(module, exports) {

$parcel$export(module.exports, "useLinkedTrelloWorkspaceTraitSelector", () => $01c6496536a406d4$export$11aeed7eb2d4ff8c);

var $5GDqD = parcelRequire("5GDqD");
const $01c6496536a406d4$export$11aeed7eb2d4ff8c = (0, $5GDqD.createTraitsSelector)('SITE', ({ getTraitByName: getTraitByName })=>{
    return !!getTraitByName('jira_workmanagement_linked_trello_workspace')?.value;
});

});


parcelRegister("byS8t", function(module, exports) {

$parcel$export(module.exports, "useConvertToRootTaskList", () => $7e85bec4cfe468a8$export$52350a71fa563521);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $8Bc5A = parcelRequire("8Bc5A");

var $55tv8 = parcelRequire("55tv8");
const $7e85bec4cfe468a8$export$52350a71fa563521 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((taskItems)=>{
        const filteredTaskItems = taskItems.filter((task)=>(0, $8Bc5A.allTasksExcludingJSMBusinessTasks).includes(task));
        if (filteredTaskItems.length === 0) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'quickstartTaskList mismatched', {
                taskItems: taskItems
            });
            return undefined;
        }
        return {
            root: {
                title: (0, $55tv8.messages).rootTitle,
                items: filteredTaskItems
            }
        };
    }, [
        createAnalyticsEvent
    ]);
};

});
parcelRegister("55tv8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a60625a31fb4f969$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a60625a31fb4f969$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "onboarding-quickstart-core.utils.create-task-list.root-title",
        "defaultMessage": "Quickstart"
    }
});

});


const $08a37b02293d63ea$export$d2fcfad22215d3a3 = '/people';
const $08a37b02293d63ea$export$7c6780602715dd47 = '/settings/request-types';
const $08a37b02293d63ea$export$7593cbf14f41f9a1 = '/settings/email';
const $08a37b02293d63ea$export$b06c4270dc16727f = '/settings/chat';
const $08a37b02293d63ea$export$3e8b796a515650a1 = '/settings/portal-settings';

parcelRegister("fZRGa", function(module, exports) {

$parcel$export(module.exports, "extractTrailingSlashFromPath", () => $25d037ca117ae5ed$export$4e1e835a1af3ba50);
const $25d037ca117ae5ed$export$4e1e835a1af3ba50 = (path)=>path.replace(/\/$/, '');

});

const $e7830161eb8674f1$export$6f454e69bce3a691 = 'business';
const $e7830161eb8674f1$export$e6952b12ade67489 = 'default';

parcelRegister("gWE9S", function(module, exports) {

$parcel$export(module.exports, "useIsSampleProjectService", () => $c05aee306f77b927$export$7c31b8e3dc4a5de0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $bXw8Z = parcelRequire("bXw8Z");
const $c05aee306f77b927$var$initialState = {};
const $c05aee306f77b927$var$store = (0, $iXqE5.createStore)({
    name: 'jwm-quickstart-is-sample-project',
    initialState: $c05aee306f77b927$var$initialState,
    actions: $bXw8Z.actions
});
const $c05aee306f77b927$export$7c31b8e3dc4a5de0 = (0, $3sQ5x.createHook)($c05aee306f77b927$var$store);

});
parcelRegister("bXw8Z", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4da4050f584fa8d0$export$e324594224ef24da);

var $kPeNb = parcelRequire("kPeNb");
const $4da4050f584fa8d0$export$e324594224ef24da = {
    fetchIsSampleProject: $kPeNb.fetchIsSampleProject
};

});
parcelRegister("kPeNb", function(module, exports) {

$parcel$export(module.exports, "fetchIsSampleProject", () => $87d81bf4bc3fa8ca$export$be137911e8102855);

var $eusud = parcelRequire("eusud");
const $87d81bf4bc3fa8ca$var$getIsSampleProject = async (projectKey)=>{
    try {
        const response = await (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKey}/properties/isDemo`);
        return response.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return false;
    }
};
const $87d81bf4bc3fa8ca$export$be137911e8102855 = (projectKey)=>async ({ getState: getState, setState: setState })=>{
        const currentState = getState();
        if (projectKey in currentState) return;
        const isSampleProject = await $87d81bf4bc3fa8ca$var$getIsSampleProject(projectKey);
        setState({
            [projectKey]: isSampleProject
        });
    };

});



parcelRegister("6MqfV", function(module, exports) {

$parcel$export(module.exports, "useRefreshOnJSMProjectSwitch", () => $4b5cbff36d91cc78$export$baa0db9dc3861527);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $cE2Qr = parcelRequire("cE2Qr");
const $4b5cbff36d91cc78$export$baa0db9dc3861527 = (projectId, projectType)=>{
    const [, { resetIsQuickstartLoaded: resetIsQuickstartLoaded }] = (0, $cE2Qr.useJswOnboarding)();
    (0, $5uXOq.useEffect)(()=>{
        if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) resetIsQuickstartLoaded();
    }, [
        resetIsQuickstartLoaded,
        projectId,
        projectType
    ]);
};

});

parcelRegister("bPD6R", function(module, exports) {

$parcel$export(module.exports, "useRefreshQuickstartOnProjectSwitch", () => $c696f71579cc298d$export$610571bb07c3f15a);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $cE2Qr = parcelRequire("cE2Qr");

var $6MqfV = parcelRequire("6MqfV");
const $c696f71579cc298d$export$610571bb07c3f15a = (projectContextData)=>{
    const [{ quickstartStateProjectType: quickstartStateProjectType }, { resetIsQuickstartLoaded: resetIsQuickstartLoaded }] = (0, $cE2Qr.useJswOnboarding)();
    // Handles JSM projects
    (0, $6MqfV.useRefreshOnJSMProjectSwitch)(projectContextData?.projectId, projectContextData?.projectType);
    // Handles all other non JSM project types
    (0, $5uXOq.useEffect)(()=>{
        if (projectContextData?.projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT) && quickstartStateProjectType !== projectContextData?.projectType) resetIsQuickstartLoaded();
    }, [
        resetIsQuickstartLoaded,
        projectContextData?.projectType,
        quickstartStateProjectType
    ]);
};

});

parcelRegister("2S7gn", function(module, exports) {

$parcel$export(module.exports, "useQuickstart", () => $ee4740cbfba38ee1$export$eee715064db7b785);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4DPZY = parcelRequire("4DPZY");


var $jrUuh = parcelRequire("jrUuh");

var $6yXtV = parcelRequire("6yXtV");
const $ee4740cbfba38ee1$export$eee715064db7b785 = (projectContextData)=>{
    const [{ data: containerContext }] = (0, $4DPZY.useContainerContext)();
    const [{ isReady: spaStatePageReady }] = (0, $6yXtV.useSpaStatePageReady)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $jrUuh.useJsmOnboardingType)();
    (0, $5uXOq.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        jsmOnboardingData,
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    if (projectContextData?.projectType !== (0, $2vSU6.SOFTWARE_PROJECT) && projectContextData?.projectType !== (0, $2vSU6.CORE_PROJECT) && projectContextData?.projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT)) // If projectContext is present and it is not software, core or service management, don't render
    return false;
    // Scope Type in classic -- scrum/kanban/undefined(non-scrum/kanban) & next-gen -- simple
    const isProjectScopeAvailable = containerContext && containerContext.scope && containerContext.scope.type;
    const isProjectScopeAndSpaPageReady = Boolean(isProjectScopeAvailable) && spaStatePageReady;
    const showJwmExperience = containerContext?.contextType === 'project' && projectContextData?.projectType === (0, $2vSU6.CORE_PROJECT);
    const showJsmExperience = containerContext?.contextType === 'project' && projectContextData?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $e7830161eb8674f1$export$6f454e69bce3a691);
    const canShowExperience = showJwmExperience || showJsmExperience || isProjectScopeAndSpaPageReady;
    return canShowExperience;
};

});

parcelRegister("lQB52", function(module, exports) {

$parcel$export(module.exports, "getUserRole", () => $43cd27dfa61aaa51$export$c33a4269214e2ec4);
$parcel$export(module.exports, "getCanInvitePeopleToProject", () => $43cd27dfa61aaa51$export$7155ad229e9ef96);

var $iMd5l = parcelRequire("iMd5l");

var $ieqoN = parcelRequire("ieqoN");


var $ldyPw = parcelRequire("ldyPw");
const $43cd27dfa61aaa51$export$c33a4269214e2ec4 = (isSiteAdmin, isAdmin)=>{
    if (isSiteAdmin) return (0, $ieqoN.USER_ROLE).SITE_ADMIN;
    if (isAdmin) return (0, $ieqoN.USER_ROLE).JIRA_ADMIN;
    return (0, $ieqoN.USER_ROLE).END_USER;
};
const $43cd27dfa61aaa51$export$7155ad229e9ef96 = (projectContext, tenantContext)=>{
    const isProjectAdmin = Boolean(projectContext && projectContext.isProjectAdmin) || tenantContext.isAdmin;
    const isInFreeClassicProject = projectContext && !projectContext.simplified && (0, $iMd5l.getProductEdition)((0, $c06e1abca7c13910$export$1346c9aa3cbb477d), tenantContext) === (0, $ldyPw.FREE_EDITION);
    return isProjectAdmin && !isInFreeClassicProject;
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';





parcelRegister("77Zff", function(module, exports) {

$parcel$export(module.exports, "shouldRouteShowQuickstartOnboarding", () => $0ba707d97438beee$export$25ddf6cfdf6af9c5);

var $c0dQj = parcelRequire("c0dQj");
const $0ba707d97438beee$var$allowedRoutes = new Set([
    'classic-business-summary',
    'classic-business-timeline',
    'classic-business-approvals',
    'classic-business-list',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-form',
    'classic-business-form-builder',
    'project-pages'
]);
const $0ba707d97438beee$export$25ddf6cfdf6af9c5 = (routeName)=>{
    if ((0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)()) return false;
    return $0ba707d97438beee$var$allowedRoutes.has(routeName);
};

});



//# sourceMappingURL=async-business-project-onboarding.453408fb.js.map
